import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SelectOptionDialogItem {
  value: string;
  label: string;
}

export interface SelectOptionDialogData {
  title?: string;
  message: string;
  options: SelectOptionDialogItem[];
  selectedValue?: string;
}

@Component({
  selector: 'hc-select-option-dialog',
  template: `
    <div fxLayout="column" style="padding: 15px; min-width: 360px; max-width: 90vw;">
      <h1 mat-dialog-title *ngIf="data.title">{{ data.title | trans }}</h1>
      <div mat-dialog-content fxLayout="column" fxLayoutGap="10px">
        <p>{{ data.message | trans }}</p>
        <mat-form-field fxFlex>
          <mat-label>{{ data.title ? (data.title | trans) : ('admin.web.select-value' | trans) }}</mat-label>
          <mat-select [(ngModel)]="data.selectedValue">
            <mat-option *ngFor="let option of data.options" [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div mat-dialog-actions fxFlex="1 0 100%" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button mat-raised-button (click)="clickCancel()">{{ 'admin.web.cancel' | trans }}</button>
        <button mat-raised-button color="primary" (click)="clickOk()" cdkFocusInitial>{{ 'admin.web.ok' | trans }}</button>
      </div>
    </div>
  `
})
export class SelectOptionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SelectOptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectOptionDialogData,
  ) {
    if (!this.data.options) {
      this.data.options = [];
    }
    if (!this.data.selectedValue && this.data.options.length > 0) {
      this.data.selectedValue = this.data.options[0].value;
    }
  }

  clickOk(): void {
    this.dialogRef.close(this.data.selectedValue);
  }

  clickCancel(): void {
    this.dialogRef.close(false);
  }
}